/**
 * Table-number ranges for "Add a range of tables" (DineOpsTableRangeModal).
 * Kept apart from the modal so it is testable without the UI imports.
 * Same limits as the API: at most 200 per batch, numbers up to 20 characters.
 */
export const MAX_TABLES = 200;
export const MAX_LENGTH = 20;

/**
 * T + 1..35 + padding -> T01..T35. Padding is at least two digits, wider when the range needs it.
 * Stops one past MAX_TABLES so the caller can refuse an oversized range without building it whole.
 */
export const expandTableRange = (prefix: string, from: number, to: number, pad: boolean): string[] => {
  if (!Number.isInteger(from) || !Number.isInteger(to) || from < 0 || to < from) return [];
  const width = pad ? Math.max(2, String(to).length) : 0;
  const out: string[] = [];
  for (let n = from; n <= to && out.length <= MAX_TABLES; n++) out.push(`${prefix}${String(n).padStart(width, '0')}`);
  return out;
};
